import React from 'react';
import './category.scss';
import LocationNav from '../../components/mweb/LocationNav/LocationNav';
import SearchBar from '../../components/mweb/SearchBar/SearchBar';
import AppBar from '../../components/mweb/AppBar/AppBar';
import Loader from '../../components/mweb/Skeletons/Loader/Loader';
import Categories from '../../components/mweb/Categories/Categories';
import { getCategories } from 'hb-redux-store/feature/products/product.action';
import { connect } from 'react-redux';

class Category extends React.Component {
  componentDidMount() {
    this.props.getCategories();
  }

  render() {
    const {
      categories,
      loadingCategories,
      launchInfo,
      cartQty,
      notifications,
    } = this.props;
    return (
      <div className="category">
        <div className="std-margin-lr">
          <LocationNav launchInfo={launchInfo} notifications={notifications} />
          <SearchBar />
        </div>
        {loadingCategories && !categories && <Loader />}
        {!loadingCategories && categories && (
          <Categories title="Search By Category" categories={categories} />
        )}
        <AppBar cartQty={cartQty} launchInfo={launchInfo} />
      </div>
    );
  }
}

const mapStateToProps = rootReducer => ({
  categories: rootReducer.productReducer.categories,
  loadingCategories: rootReducer.productReducer.loadingPdp,
  launchInfo: rootReducer.initialReducer.launchInfo,
  cartQty: rootReducer.cartReducer.cartQtyCount,
  notifications: rootReducer.notificationReducer.notifications,
});

const mapDispatchToProps = { getCategories };

export default connect(mapStateToProps, mapDispatchToProps)(Category);
